module.exports = __webpack_public_path__ + "img/Mockup_A4_Brochure_1.01d603e3.png";